import { ItherapyMatch } from '../interfaces/therapy-match.interface';

export class TherapyEditPayload {
  constructor(public therapy: ItherapyMatch,
              public testId: string,
              public forms: Array<{ title?: string, path?: string, formId: string, type: 'array' | 'single'}>) { }
}
